module.exports = __webpack_public_path__ + "static/CV_Jelena_Ferrelli-52e52f596a54f8efec4b4c852de421e0.pdf";